import { Card, Checkbox, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataCapturePolicy from "../modals/DataCapturePolicy";
import Loader from "../Loader";
import { joiningValidateApi } from "../../api";
import WebUtils from "../utils/WebUtils";
import axios from "axios";
import Utils from "../utils/Utils";

function LoginRightSection({ loginFormObj, interviewData, loginQuery }) {
  const [dataCaptureModal, setDataCaptureModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const handleDataCaptureModal = () => {
    setDataCaptureModal(true);
  };

  const [form] = Form.useForm();
  const [isUserRoleDisabled, setIsUserRoleDisabled] = useState(false);
  const [dataProtection, setDataProtection] = useState(false);
  let data = {};

  // Handle the changes in the interviewType dropdown
  const handleInterviewTypeChange = (value) => {
    if (value === "AI_TWO_WAY" || value === "AI_ONE_WAY") {
      form.setFieldsValue({ userRole: "CANDIDATE" });
      setIsUserRoleDisabled(true); // Disable the second dropdown
    } else {
      form.setFieldsValue({ userRole: undefined });
      setIsUserRoleDisabled(false); // Enable the second dropdown
    }
  };

  const joiningApi = (value) => {
    setErrorMsg(null);
    let url = `${joiningValidateApi}?interviewId=${value?.interviewId}&interviewPasscode=${value?.passcode}&userRole=${value?.userRole}&interviewType=${value?.interviewType}`;
    setLoading(true);

    const interviewDetails = {
      ...value,
      ...interviewData,
    };

    axios
      .post(url)
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          localStorage.setItem("userDetails", JSON.stringify(result.data.data));
          localStorage.setItem("loginQuery", JSON.stringify(loginQuery));
          localStorage.setItem(
            "interviewDetails",
            JSON.stringify(interviewDetails)
          );
          if (result.data.data.interviewState === "YET_TO_START") {
            window.location.href = `/preview?interviewId=${loginFormObj?.interviewId}`;
          } else if (result.data.data.interviewState === "COMPLETED") {
            window.location.href = `/interview-completed?interviewId=${loginFormObj?.interviewId}`;
          }
        } else if (
          result.data.resultStatusInfo.resultCode === "UNAUTHORIZED" ||
          result.data.resultStatusInfo.resultCode === "NOT_FOUND"
        ) {
          setErrorMsg("Invalid assessment id or passcode.");
        } else if (result.data.resultStatusInfo.resultCode === "EXPIRED") {
          setErrorMsg(result.data.resultStatusInfo.message);
        } else {
          setErrorMsg("Something is wrong.");
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (
      loginFormObj.interviewType === "AI_TWO_WAY" ||
      loginFormObj.interviewType === "AI_ONE_WAY"
    ) {
      form.setFieldsValue({ userRole: "CANDIDATE" });
      setIsUserRoleDisabled(true);
    } else {
      form.setFieldsValue({ userRole: undefined });
      setIsUserRoleDisabled(false);
    }
  }, [loginFormObj]);

  // useEffect(() => {
  //  Utils.removeUserDetail()
  // }, []);

  return (
    <>
      {loading && <Loader />}
      {dataCaptureModal && (
        <DataCapturePolicy
          dataCaptureModal={dataCaptureModal}
          setDataCaptureModal={setDataCaptureModal}
        />
      )}
      <div className="flex justify-center items-center">
        <Card className="w-[98%] sm:w-[80%] md:w-[64%] lg:w-[92%] xl:w-[80%] 2xl:w-[73%] px-2 md:px-[0.8rem]">
          {/* <div className="text-[#101828] text-[1.3rem] font-semibold text-center mb-4">
            Join Interview Session
          </div> */}
          <Form
            layout="vertical"
            form={form}
            onFinish={joiningApi}
            className="login-form-container"
          >
            <Col span={24} className="m-auto">
              <Form.Item
                label={
                  <p className="text-[#344054] font-medium p-0 m-0">Name</p>
                }
                name="name"
                className="mb-3 "
                initialValue={interviewData?.candidateName}
                rules={[
                  {
                    required: true,
                    message: "Name cannot be empty",
                  },
                ]}
              >
                <Input
                  autoComplete="off"
                  // value={name}
                  // onChange={(e) => setName(e.target.value)}

                  className="rounded"
                  placeholder="Enter Your Name"
                  // disabled={candidateNameQuery ? true : false}
                />
              </Form.Item>
              <Form.Item
                label={
                  <p className="text-[#344054] font-medium">Assessment ID</p>
                }
                name="interviewId"
                autoComplete="off"
                initialValue={loginFormObj?.interviewId}
                className=" mb-3"
                rules={[
                  {
                    required: true,
                    message: "Assessment ID cannot be empty",
                  },
                ]}
              >
                <Input
                  // onChange={(e) => setEmail(e.target.value)}
                  // value={email}
                  autoComplete="off"
                  className="rounded"
                  placeholder="Enter Assessment ID"
                  disabled={loginFormObj?.interviewId}
                  // disabled={emailQuery ? true : false}
                />
              </Form.Item>
              <Row gutter={12} className=" p-0 m-0">
                <Col span={12} className="p-0 m-0">
                  <Form.Item
                    label={
                      <p className="text-[#344054] font-medium">
                        Assessment type
                      </p>
                    }
                    name="interviewType"
                    initialValue={loginFormObj?.interviewType}
                    className="mb-3 "
                    rules={[
                      {
                        required: true,
                        message: "Please select an option",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select assessment type"
                      className="rounded"
                      onChange={handleInterviewTypeChange}
                      disabled={loginFormObj?.interviewType}
                      // style={{ width: '300px' }}
                      dropdownStyle={{ width: "220px" }}
                    >
                      <Select.Option value="AI_TWO_WAY">
                        Conversational AI Assessment
                      </Select.Option>
                      <Select.Option value="AI_ONE_WAY">
                        AI Recorded Bot Assessment
                      </Select.Option>
                      <Select.Option value="HUMAN">
                        Human Assessment
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={
                      <p className="text-[#344054] font-medium">User role</p>
                    }
                    name="userRole"
                    className="mb-3 "
                    rules={[
                      {
                        required: true,
                        message: "Please select an option",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select user role"
                      className="rounded"
                      disabled={isUserRoleDisabled}
                    >
                      <Select.Option value="CANDIDATE">Candidate</Select.Option>
                      <Select.Option value="INTERVIEWER">
                        Panelist
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                label={<p className="text-[#344054] font-medium">Passcode</p>}
                className="mb-3"
                name="passcode"
                initialValue={loginFormObj?.passcode}
                rules={[
                  {
                    required: true,
                    message: "Passcode cannot be empty",
                  },
                ]}
              >
                <Input
                  // value={passcode}
                  autoComplete="off"
                  disabled={loginFormObj?.passcode}
                  // disabled={passcodeQuery ? true : false}
                  // onChange={(e) => setPasscode(e.target.value)}
                  className="rounded"
                  placeholder="Enter Passcode"
                />
              </Form.Item>
            </Col>

            <Col span={24} className="m-auto mt-4 flex">
              <span className="">
                <Checkbox
                  onChange={(e) => {
                    setDataProtection(e.target.checked);
                  }}
                />
              </span>
              <div className="ml-2 text-[.8rem] text-[#344054] leading-[1.25rem]">
                By proceeding with this assessment, you{" "}
                <Link
                  to="https://hireplusplus-public-de.s3.eu-central-1.amazonaws.com/UserAcceptanceAndConsentFormForVideoRecordings.pdf"
                  target="_blank"
                  className="text-[#206DC5] font-medium"
                >
                  consent
                </Link>{" "}
                to our use of your responses and
                <Link
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the default navigation behavior
                    handleDataCaptureModal(); // Open the modal
                  }}
                  className="text-[#206DC5] font-medium"
                >
                  {" "}
                  personal data
                </Link>{" "}
                in accordance with our{" "}
                <Link
                  to="https://www.hireplusplus.com/privacy-policy"
                  target="_blank"
                  className="text-[#206DC5] font-medium"
                >
                  {" "}
                  privacy policy
                </Link>{" "}
                and{" "}
                <Link
                  to="https://www.hireplusplus.com/terms-and-conditions"
                  target="_blank"
                  className="text-[#206DC5] font-medium"
                >
                  {" "}
                  terms of service
                </Link>
                .
              </div>
            </Col>
            <Col span={24} className="m-auto mt-4">
              <button
                // onClick={joiningApi}
                className={`w-full  py-2 text-[0.94rem] transition-all ${
                  dataProtection === false ? "btn-grey-disable" : "btn-blue"
                }`}
                button-type="primary"
                disabled={dataProtection === false}
                // disabled={
                //   name && email && passcode && dataProtection ? false : true
                // }
              >
                Join Assessment
              </button>
              <p className="text-red-500 font-semibold text-center">
                {errorMsg}
              </p>
            </Col>
          </Form>
        </Card>
      </div>
    </>
  );
}

export default LoginRightSection;
